export class StandardIntervalConfig {
    'intervalHours';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "intervalHours",
            "baseName": "intervalHours",
            "type": "StandardIntervalConfigIntervalHoursEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StandardIntervalConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var StandardIntervalConfigIntervalHoursEnum;
(function (StandardIntervalConfigIntervalHoursEnum) {
    StandardIntervalConfigIntervalHoursEnum[StandardIntervalConfigIntervalHoursEnum["NUMBER_6"] = 6] = "NUMBER_6";
    StandardIntervalConfigIntervalHoursEnum[StandardIntervalConfigIntervalHoursEnum["NUMBER_8"] = 8] = "NUMBER_8";
    StandardIntervalConfigIntervalHoursEnum[StandardIntervalConfigIntervalHoursEnum["NUMBER_12"] = 12] = "NUMBER_12";
})(StandardIntervalConfigIntervalHoursEnum || (StandardIntervalConfigIntervalHoursEnum = {}));
